import { render, staticRenderFns } from "./uploadCover.vue?vue&type=template&id=4e80b914&scoped=true&"
import script from "./uploadCover.vue?vue&type=script&lang=js&"
export * from "./uploadCover.vue?vue&type=script&lang=js&"
import style0 from "./uploadCover.vue?vue&type=style&index=0&id=4e80b914&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e80b914",
  null
  
)

component.options.__file = "uploadCover.vue"
export default component.exports